import React from 'react';

const SettingsTab = () => {
  return (
    <div className="settings">
      <h2>设置</h2>
    </div>
  );
};

export default SettingsTab;